import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  FormControl
} from "@angular/forms";

import { debounceTime, distinctUntilChanged, Subject, takeUntil } from "rxjs";
import { MeddraBrowserComponent } from "../jsignal-product/meddra-browser/meddra-browser.component";
import { MatDialog } from "@angular/material/dialog";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AnalysisAdvancedFilterComponent } from "../jsignal-product/analysis-advanced-filter/analysis-advanced-filter.component";
import { ColDef, SelectionChangedEvent } from "ag-grid-community";
import { SignalResultDialogComponent } from "./signal-result-dialog/signal-result-dialog.component";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";


interface Product {
  name?: string;
  id?:any;
}

@Component({
    selector: "app-jsip-analysis",
    templateUrl: "./jsip-analysis.component.html",
    styleUrls: ["./jsip-analysis.component.scss"],
    standalone: false
})
export class JsipAnalysisComponent implements OnInit {

  // =============================
  // FORM
  // =============================
  filterForm: FormGroup;
  selectedAdverseEventObject: any = null;
  appliedFilters: any[] = [];

  private destroy$ = new Subject<void>();


  // =============================
  // UI STATE
  // =============================
  showFilterPanel = false;


  // =============================
  // GRID
  // =============================
  analysisData: any[] = [];
  columnDefs: any;
  defaultColDef: any;
  gridOptions: any;
  rowClassRules: any;
  getRowStyle: any;
  gridApi: any;
typeGridApi:any;

  // =============================
  // SOURCES
  // =============================
  sources = [
    { code: 'vigibase', name: 'VigiBase' },
    { code: 'faers', name: 'FAERS' },
    { code: 'eudravigilance', name: 'EudraVigilance' },
    { code: 'company', name: 'Company Safety DB' }
  ];


  // =============================
  // ANALYSIS TYPES
  // =============================
  analysisTypes = [
    { label: 'PRR', value: 'prr', checked: true },
    { label: 'ROR', value: 'ror', checked: false },
    { label: 'IC', value: 'ic', checked: false },
    { label: 'EBGM', value: 'ebgm', checked: false },
    { label: 'Chi-Square', value: 'chi_square', checked: false }
  ];


   typeDefaultColDef: ColDef = {
    editable: false,
    sortable: false,
    filter: false,
    resizable: true,
    cellClass: 'grid-cell',
    headerClass: 'grid-header'
  };
context = { componentParent: this };
  rowData = [
     { method: 'PRR',  thresholdLimit: '',operator:'', values: '', rowSpan: 3, showMethod: true,enabled:false,thresholdEnabled:false, },
    { method: 'PRR',  thresholdLimit: 'PRR025',operator:'>=', values: '', rowSpan: 2, showMethod: false,enabled:false, thresholdEnabled:false,},
    { method: 'PRR',  thresholdLimit: 'PRR975',operator:'<=', values: '', rowSpan: 1, showMethod: false,enabled:false, thresholdEnabled:false,},
     { method: 'ROR',  thresholdLimit: '',operator:'', values: '', rowSpan: 3, showMethod: true,enabled:false, thresholdEnabled:false,},
    { method: 'ROR',  thresholdLimit: 'ROR025',operator:'>=', values: '', rowSpan: 2, showMethod: false,enabled:false, thresholdEnabled:false,},
    { method: 'ROR',  thresholdLimit: 'ROR975',operator:'<=', values: '', rowSpan: 1, showMethod: false,enabled:false, thresholdEnabled:false,},

    { method: 'IC',   thresholdLimit: '>=0 && <=2',operator:'', values: '', rowSpan: 3, showMethod: true,enabled:false, thresholdEnabled:false,},
    { method: 'IC',   thresholdLimit: 'IC025',operator:'', values: '', rowSpan: 2, showMethod: false,enabled:false, thresholdEnabled:false,},
    { method: 'IC',   thresholdLimit: 'IC975',operator:'', values: '', rowSpan: 1, showMethod: false,enabled:false, thresholdEnabled:false,},
    { method: 'EBGM', thresholdLimit: '>=0 && <=2.5',operator:'', values: '', rowSpan: 3, showMethod: true,enabled:false, thresholdEnabled:false,},
     { method: 'EBGM', thresholdLimit: 'EB05',operator:'', values: '', rowSpan: 2, showMethod: false,enabled:false, thresholdEnabled:false,},
      { method: 'EBGM', thresholdLimit: 'EB95',operator:'', values: '', rowSpan: 1, showMethod: false,enabled:false, thresholdEnabled:false,},
    { method: 'Case', thresholdLimit: 'Count >=', operator:'',values: '', rowSpan: 1, showMethod: true,enabled:false, thresholdEnabled:false,}
  ];;

  TypeColumnDefs: ColDef[] = [
   
    {
      headerName: 'Analysis Type',
      field: 'method',
      width: 120,
      rowSpan: params => params.data?.showMethod ? params.data.rowSpan : 1,
      valueGetter: params => params.data?.showMethod ? params.data.method : '',
      cellClassRules: {
        'merged-cell': params => params.data?.showMethod && params.data?.rowSpan > 1,
        'hidden-span-cell': params => !params.data?.showMethod
      },
     cellRenderer: (params) => {

          const checked = params.data.enabled ? 'checked' : '';

          const eDiv = document.createElement('div');

          eDiv.innerHTML = `
              <input type="checkbox" ${checked}/>
              ${params.data.method}
          `;

          const checkbox = eDiv.querySelector('input');

          checkbox.addEventListener('change', () => {
              params.context.componentParent.toggleRow(params.rowIndex);
          });

          return eDiv;
        }
    },
    {
      headerName: 'Threshold Limit',
      width: 220,
      cellRenderer: (params) => {
          const eDiv = document.createElement('div');
          eDiv.style.display = 'flex';
          eDiv.style.alignItems = 'center';
          eDiv.style.height = '100%';

          if (!params.data.thresholdEnabled) {
            eDiv.innerHTML = `${params.data.thresholdLimit} ${params.data.operator}`;
            return eDiv;
          }

          const input = document.createElement('input');
          input.type = 'text';
          input.value = params.data.thresholdLimit || '';
          input.style.width = '120px';
          input.style.height = '28px';
          input.style.padding = '4px';

          input.addEventListener('input', (event: any) => {
            params.context.componentParent.updateThreshold(
              params.rowIndex,
              event.target.value
            );
          });

          const text = document.createElement('span');
          text.style.marginLeft = '8px';
          text.innerText = params.data.operator || '';

          eDiv.appendChild(input);
          eDiv.appendChild(text);

          return eDiv;
        }
    },
    {
      headerName: 'Values',
      flex: 1,
       cellRenderer: (params) => {
          const eDiv = document.createElement('div');
          eDiv.style.display = 'flex';
          eDiv.style.alignItems = 'center';
          eDiv.style.height = '100%';

          if (!params.data.enabled) {
            eDiv.innerText = params.data.values ?? '';
            return eDiv;
          }

          const input = document.createElement('input');
          input.type = 'number';
          input.value = params.data.values ?? '';
          input.style.width = '120px';
          input.style.height = '28px';
          input.style.padding = '4px';

          input.addEventListener('input', (event: any) => {
            params.context.componentParent.updateValue(
              params.rowIndex,
              event.target.value
            );
          });

          eDiv.appendChild(input);

          return eDiv;
        }
    }
  ];
selectedProduct:any;
productsDisplayed:any = [];
 products:any = [];
   components: any;

  // =============================
  // CONSTRUCTOR
  // =============================
  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    public jsignalsService: JsignalService,
    public spinner: NgxUiLoaderService,
    public commonService: CommonService,
    private snackBar: MatSnackBar
  ) {

    this.filterForm = this.fb.group({
      source: [''],
      product: [''],
      adverseEvent: [''],
      analysisTypes: this.fb.array(
        this.analysisTypes.map(type => new FormControl(type.checked))
      )
    });

     this.components = {
          jsignalButton: JSIGNALBUTTON,
        };

  }


  // =============================
  // GETTER
  // =============================
  get analysisTypesFormArray(): FormArray {
    return this.filterForm.get('analysisTypes') as FormArray;
  }


  // =============================
  // INIT
  // =============================
  ngOnInit(): void {

    // this.initializeGrid(); // COMMENTED OUT - Not currently using
    this.loadJobs();

    this.filterForm.get("product")
      ?.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe();

        this.jsignalsService.getProductList().subscribe({
  next: (response: any[]) => {
    try {
      // Validate response type before mapping
      if (!Array.isArray(response)) {
        throw new Error('Invalid response type: expected an array.');
      }

      // Map both id and name safely
      this.products = response.map((item, index) => {
        if (!item || typeof item !== 'object') {
          throw new Error(`Invalid item at index ${index}: ${JSON.stringify(item)}`);
        }

        return {
          id: item.id,
          name: item.name
        } as Product;
      });
      // Initialize your displayed & selected arrays
      this.productsDisplayed = [{ id: null, name: 'None' } as Product,...this.products];
      this.selectedProduct = this.products[0] || null;
    } catch (error) {
      console.error(' Error while processing product list:', error);
      
    }
  },
  error: (err) => {
    console.error(' API Error while fetching product list:', err);
  },
});

  }


  // =============================
  // GRID INITIALIZATION
  // =============================
  initializeGrid() {

    // COMMENTED OUT - Old column definitions not currently in use
    // this.columnDefs = [
    //   {
    //     headerName: "PRR",
    //     field: "prr",
    //     width: 120,
    //     ...this.jsignalsService.autoTooltip("PRR"),
    //   },
    //   {
    //     headerName: "PRR-025",
    //     field: "prr_025",
    //     width: 120,
    //     ...this.jsignalsService.autoTooltip("PRR-025"),
    //   },
    //   {
    //     headerName: "PRR-975",
    //     field: "prr_975",
    //     width: 120,
    //     ...this.jsignalsService.autoTooltip("PRR-975"),
    //   },
    //   {
    //     headerName: "ROR",
    //     field: "ror",
    //     width: 120,
    //     ...this.jsignalsService.autoTooltip("ROR"),
    //   },
    //   {
    //     headerName: "ROR CI Lower",
    //     valueGetter: (params: any) => params.data?.ror_ci?.[0],
    //     width: 150,
    //   },
    //   {
    //     headerName: "ROR CI Upper",
    //     valueGetter: (params: any) => params.data?.ror_ci?.[1],
    //     width: 150,
    //   },
    //   {
    //     headerName: "Chi-Square",
    //     field: "chi_square",
    //     width: 140,
    //   },
    //   {
    //     headerName: "IC",
    //     field: "IC",
    //     width: 200,
    //   },
    //   {
    //     headerName: "IC025",
    //     field: "ic_025",
    //     width: 120,
    //   },
    //   {
    //     headerName: "IC975",
    //     field: "ic_975",
    //     width: 120,
    //   },
    //   {
    //     headerName: "EBGM",
    //     field: "ebgm",
    //     width: 120,
    //   },
    //   {
    //     headerName: "EB05",
    //     field: "eb05",
    //     width: 120,
    //   },
    //   {
    //     headerName: "EB95",
    //     field: "eb95",
    //     width: 120,
    //   },
    //   {
    //     headerName: "Case count",
    //     field: "caseCount",
    //     width: 120,
    //   }
    // ];
    
    // CURRENTLY USING - Active column definitions
    this.columnDefs = [
  { headerName: "Drug", field: "drug_name", width: 140 },
  { headerName: "Event", field: "event_term", width: 140 },
  { headerName: "Case Count", field: "observed_count", width: 120 },

  { headerName: "PRR", field: "prr", width: 120 },
  { headerName: "PRR CI Low", field: "prr_ci_low", width: 140 },
  { headerName: "PRR CI High", field: "prr_ci_high", width: 140 },

  { headerName: "ROR", field: "ror", width: 120 },
  { headerName: "ROR CI Low", field: "ror_ci_low", width: 140 },
  { headerName: "ROR CI High", field: "ror_ci_high", width: 140 },

  { headerName: "Chi-Square", field: "chi_square", width: 140 },

  { headerName: "IC", field: "ic", width: 120 },
  { headerName: "IC025", field: "ic025", width: 120 },
  { headerName: "IC975", field: "ic975", width: 120 },

  { headerName: "EBGM", field: "ebgm", width: 120 },
  { headerName: "EB05", field: "eb05", width: 120 },
  { headerName: "EB95", field: "eb95", width: 120 }
];

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.gridOptions = {
      rowHeight: 40,
    };

    this.rowClassRules = {
      sick: (params: any) => params.node.data.status === "No",
    };

    this.getRowStyle = (params: any) => {

      if (params.data.status === "No") {
        return { backgroundColor: "rgb(211,211,211)" };
      }

      return null;
    };
  }


  // =============================
  // RUN ANALYSIS
  // =============================
  // COMMENTED OUT - Old runAnalysis implementation
  // runAnalysis(): void {
  //   console.log(this.rowData);
  //   
  //   if (!this.isSelectionValid()) {
  //     this.snackBar.open("Please select Product and Adverse Event", "Close", { duration: 3000 });
  //     return;
  //   }
  //
  //   const selectedAnalysisTypes = this.getSelectedAnalysisTypes();
  //
  //   this.spinner.start();
  //
  //   setTimeout(() => {
  //
  //     this.analysisData = [
  //       {
  //         prr: 2.5,
  //         prr_025: 1.8,
  //         prr_975: 3.2,
  //         ror: 2.8,
  //         chi_square: 15.6,
  //         IC: 1.8,
  //         ebgm: 2.2,
  //         status: "Yes"
  //       }
  //     ];
  //
  //     if (this.gridApi) {
  //       this.gridApi.setGridOption('rowData', this.analysisData);
  //     }
  //
  //     this.spinner.stop();
  //
  //     this.snackBar.open("Analysis completed successfully", "Close", { duration: 3000 });
  //
  //   }, 800);
  // }

// CURRENTLY USING - Active runAnalysis implementation
runAnalysis(): void {
  // COMMENTED OUT - Validation temporarily disabled
  // if (!this.isSelectionValid()) {
  //   this.snackBar.open("Please select Product and Adverse Event", "Close", { duration: 3000 });
  //   return;
  // }

  const drug = this.filterForm.get("product")?.value;
  const event = this.filterForm.get("adverseEvent")?.value;

  this.spinner.start();

  this.jsignalsService.detectSignal(drug, event, 'all')
    .subscribe({
      next: (res: any) => {
  const jobId = res.jobId;

  this.snackBar.open("Job submitted", "Close", { duration: 3000 });

  this.loadJobs();
  this.spinner.stop(); // 👈 refresh grid

},

      error: (err) => {
        console.error("API Error:", err);
        this.snackBar.open(
          "Signal service is unavailable. Please try later.",
          "Close",
          { duration: 3000 }
        );
        this.analysisData = [];
        this.gridApi?.setGridOption('rowData', []);
        this.spinner.stop();
      }
    });
}

// COMMENTED OUT - Old mapping function
// mapApiResponseToGrid(response: any): any {
//   return {
//     // PRR
//     prr: response.prr ?? null,
//     prr_025: response.prr_ci_low ?? null,
//     prr_975: response.prr_ci_high ?? null,
//
//     // ROR
//     ror: response.ror ?? null,
//     ror_ci_low: response.ror_ci_low ?? null,
//     ror_ci_high: response.ror_ci_high ?? null,
//
//     // Chi-Square
//     chi_square: response.chi_square ?? null,
//
//     // IC  ⚠️ FIX HERE
//     IC: response.ic ?? null,
//     ic_025: response.ic025 ?? null,   // FIXED
//     ic_975: response.ic975 ?? null,   // FIXED
//
//     // EBGM
//     ebgm: response.ebgm ?? null,
//     eb05: response.eb05 ?? null,
//     eb95: response.eb95 ?? null,
//
//     // Case Count
//     caseCount: response.observed_count ?? response.A ?? null,
//
//     // Metadata
//     drug_name: response.drug_name ?? '',
//     event_type: response.event_term ?? ''  };
// }

// CURRENTLY USING - Active mapping function
mapApiResponseToGrid(res: any): any {
  return {
    drug_name: res.drug_name ?? '',
    event_term: res.event_term ?? '',
    observed_count: res.observed_count ?? 0,

    prr: res.prr ?? null,
    prr_ci_low: res.prr_ci_low ?? null,
    prr_ci_high: res.prr_ci_high ?? null,

    ror: res.ror ?? null,
    ror_ci_low: res.ror_ci_low ?? null,
    ror_ci_high: res.ror_ci_high ?? null,

    chi_square: res.chi_square ?? null,

    ic: res.ic ?? null,
    ic025: res.ic025 ?? null,
    ic975: res.ic975 ?? null,

    ebgm: res.ebgm ?? null,
    eb05: res.eb05 ?? null,
    eb95: res.eb95 ?? null
  };
}
  // =============================
  // GET SELECTED ANALYSIS TYPES
  // =============================
  getSelectedAnalysisTypes(): string[] {

    const selectedFlags = this.analysisTypesFormArray.value;

    return selectedFlags
      .map((checked: boolean, index: number) =>
        checked ? this.analysisTypes[index].value : null
      )
      .filter((value: string | null) => value !== null);
  }


  // =============================
  // VALIDATION
  // =============================
  isSelectionValid(): boolean {

    const product = this.filterForm.get("product")?.value;
    // const adverseEvent = this.filterForm.get("adverseEvent")?.value;

    return !!product;
  }


  // =============================
  // GRID READY
  // =============================
  onGridReady(params: any) {
    this.gridApi = params.api;
  }


  // =============================
  // MEDDRA BROWSER
  // =============================
  openMedDrabrowser(event: Event): void {

    event.stopPropagation();

    const dialogRef = this.dialog.open(MeddraBrowserComponent, {
     width: '95vw',
    height: '95vh',
    maxWidth: '95vw',
    panelClass: 'meddra-dialog',
    disableClose: true,
    autoFocus: false,
    data: {
      mode: 'select'
    }
  });


    dialogRef.afterClosed().subscribe(result => {

      if (!result) return;

      const item = result[0];

      this.filterForm.patchValue({
        adverseEvent: item.name,
      });

      this.selectedAdverseEventObject = result;
    });
  }


  // =============================
  // CLEAR METHODS
  // =============================
  clearProduct(event: Event): void {

    event.stopPropagation();

    this.filterForm.patchValue({ product: "" });
  }


  clearAdverseEvent(event: Event): void {

    event.stopPropagation();

    this.filterForm.patchValue({ adverseEvent: "" });
  }


  clearFilters(): void {

    this.filterForm.reset({
      source: '',
      product: '',
      adverseEvent: '',
      analysisTypes: this.analysisTypes.map(type => type.checked)
    });

    this.analysisData = [];

    if (this.gridApi) {
      this.gridApi.setGridOption('rowData', []);
    }
  }


  // =============================
  // REFRESH & DOWNLOAD
  // =============================
  onRefresh() {
    this.loadJobs();
  }


  onDownload() {

    if (this.gridApi) {

      this.gridApi.exportDataAsExcel({
        fileName: "SignalDetection.xlsx"
      });

    }
  }


  // =============================
  // ANALYSIS TYPE CHANGE
  // =============================
  onAnalysisTypeChange(type: any) {
    // optional
  }


  // =============================
  // ADVANCED FILTER
  // =============================
  openAdvancedFilterDialog(): void {

    const source = this.filterForm.get('source')?.value;

    if (!source) {
      this.snackBar.open("Please select Dataset first", "Close", { duration: 3000 });
      return;
    }

    const dialogRef = this.dialog.open(AnalysisAdvancedFilterComponent, {
      width: '750px',
      disableClose: true,
      data: { source }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (!result) return;

      this.appliedFilters = result;
    });

  }


  removeAppliedFilter(index: number): void {
    this.appliedFilters.splice(index, 1);
  }

  onCellClicked(event){
    console.log(event);
  }
  
    onSelectionChanged(event: SelectionChangedEvent): void {
      // event.api.getSelectedRows();
      console.log( event);
      
    }
    toggleRow(index){
      let method = this.rowData[index].method
      for(let i=0;i<this.rowData.length;i++){
        if(method == this.rowData[i].method && this.rowData[i].thresholdLimit){
           this.rowData[i].enabled = !this.rowData[i].enabled;
           this.rowData[i].thresholdEnabled = !this.rowData[i].thresholdEnabled;
        }else if(method == this.rowData[i].method && !this.rowData[i].thresholdLimit){
            this.rowData[i].enabled = !this.rowData[i].enabled;
        }
      }
     
      console.log(this.rowData);

      this.typeGridApi.setGridOption('rowData', this.rowData);
    }
    updateThreshold(index,value){

      this.rowData[index].thresholdLimit = value;
      this.typeGridApi.setGridOption('rowData', this.rowData);
      }
    updateValue(index,value){

      this.rowData[index].values = value;
      this.typeGridApi.setGridOption('rowData', this.rowData);
    }
    onTypeGridReady(params){

      this.typeGridApi = params.api;

    }

    jobList: any[] = [];
jobGridApi: any;
jobColumnDefs = [
  { headerName: "Job ID", field: "id",     flex:1, ...this.jsignalsService.autoTooltip("Job ID"),
 },
  { headerName: "Drug", field: "drug",     flex:2, ...this.jsignalsService.autoTooltip("Drug")
 },
  { headerName: "Event", field: "event",     flex:2, ...this.jsignalsService.autoTooltip("Event")
 },
  {
    headerName: "Status",
    field: "status",
    flex:1,
    ...this.jsignalsService.autoTooltip("Status"),
  },

  {
    headerName: "Created",
    field: "createdDate",
    flex:1,
    ...this.jsignalsService.autoTooltip("Created"),
    valueFormatter: p => this.jsignalsService.toYYYYMMDD(p.value)
  },

   {
      headerName: "Action",
      filter: false,
      cellRenderer: "jsignalButton",
      pinned: "right",
      lockPinned: true,
      headerTooltip: "Action",
      cellRendererParams: (params: any) => ({
        onPreview: this.previewFile.bind(this),
      }),
      width: 100,
      hide: false,
    },

];
onJobGridReady(params: any) {
  this.jobGridApi = params.api;
}
    loadJobs() {
      this.spinner.start();
  this.jsignalsService.getAllAnalyses()
    .subscribe({
      next: (res: any[]) => {
        this.jobList = res || [];
        this.jobGridApi?.setGridOption('rowData', this.jobList);
        this.spinner.stop();
      },
      error: (error: any) => {
        console.error("Failed to load jobs");
        this.snackBar.open(error.error.statusMessage, "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      }
    });
}
openResultDialog(jobId: number) {
  console.log("Opening results for job ID:", jobId);
  this.dialog.open(SignalResultDialogComponent, {
    width: '90vw',
    height: '90vh',
    data: { jobId }
  });
} 
 previewFile({ rowData }: any): void {
  const jobId = rowData.id;
  this.openResultDialog(jobId);
  }

}